import { render, staticRenderFns } from "./QuizSettingModal.vue?vue&type=template&id=5e36b620&scoped=true&"
import script from "./QuizSettingModal.vue?vue&type=script&lang=js&"
export * from "./QuizSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizSettingModal.vue?vue&type=style&index=0&id=5e36b620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36b620",
  null
  
)

export default component.exports